import React from "react";

const Footer = () => {
  return (
    <div>
      <div>
        <p className="font-extrabold text-6xl text-red-400 ">
          Questions? Call 000-800-919-1694
        </p>
        <ul>
          <li>
            <span>FAQ</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
